/** The landing page's navigation, shared by the header and the footer. */
export const NAV_LINKS = [
  { label: "Features", href: "#features" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
  { label: "Help", href: "/docs" },
];
